<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M6.60716 3.27784V5.35208H8.14734V3.27784C8.14734 2.84825 7.80256 2.5 7.37725 2.5C6.95194 2.5 6.60716 2.84825 6.60716 3.27784Z"
      fill="#0B1922"
      fill-opacity="0.75"
    />
    <path
      d="M6.60716 16.503V9.50055H8.14734V16.503C8.14734 16.6462 8.26227 16.7623 8.40404 16.7623H15.603V18.3179H8.40404C7.41165 18.3179 6.60716 17.5053 6.60716 16.503Z"
      fill="#0B1922"
      fill-opacity="0.75"
    />
    <path
      d="M19.7101 18.3179V16.7623H21.7299C22.1552 16.7623 22.5 17.1105 22.5 17.5401C22.5 17.9697 22.1552 18.3179 21.7299 18.3179H19.7101Z"
      fill="#0B1922"
      fill-opacity="0.75"
    />
    <path
      d="M18.4267 8.46343V21.7222C18.4267 22.1518 18.0819 22.5 17.6566 22.5C17.2312 22.5 16.8865 22.1518 16.8865 21.7222V8.46343C16.8865 8.32024 16.7715 8.20415 16.6298 8.20415H3.27009C2.84478 8.20415 2.5 7.8559 2.5 7.42631C2.5 6.99673 2.84478 6.64848 3.27009 6.64848H16.6298C17.6222 6.64848 18.4267 7.46106 18.4267 8.46343Z"
      fill="#0B1922"
      fill-opacity="0.75"
    />
  </svg>
</template>

<script setup lang="ts"></script>
